import {
	Timeline
} from 'antd';
import {
	WeaNewScroll
} from 'ecCom';
import Detail from './Detail';

export default class Line extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {
			details,
			scrollY
		} = this.props;

		return (
			<div className='chart'>
				<WeaNewScroll height={scrollY - 110}>
					<div className='timeline'>
							<Timeline>
								{
									details.map(detail => {
										return (
											<Timeline.Item>
												<Detail detail={detail}/>
											</Timeline.Item>
										)
									})
								}
							</Timeline>
					</div>
				</WeaNewScroll>
			</div>
		);
	}

}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrmAttendance/components/absenceDetail/Timeline.js